import React from "react";
import { useState, useEffect } from "react";
import { Box, Button, Typography } from "@mui/material";
import { func } from "helpers";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Store from "_Store";
export default function AdminHeader() {
  const [ conseiller, setConseiller ] = useState(undefined);
  const {setUtils, setAuth } = React.useContext(Store);

  useEffect(() => {
    console.log("hes")
   let connected_conseiller= func.getStorageJson('connected_conseiller');
   if(connected_conseiller) setConseiller(connected_conseiller)
  }, []);

  const returnToAdmin = () => {
    setUtils("loading", { spinning: true, primary: "" });
    let connected_conseiller = func.getStorageJson('connected_conseiller')
    if(connected_conseiller){
      let admin_token= func.getStorageJson('admin_token');
      const user = connected_conseiller;
      const token = admin_token;
      setAuth(user, token);
      func.delStorage('connected_conseiller')
      func.delStorage('admin_token')
      window.location = window.location.origin+'/admin';
   }
  }

  return (
    conseiller ? 
      <div>
        <div className="w-full sm:max-w-screen-2xl mx-auto flex flex-col">
        <div className="user_header"  style={{ backgroundColor:"orange",color:"#fff" }}>
          <div className="user_img" style={{ display: "contents" }}>
            <div
              style={{
                display: "flex",
                paddingRight: "51px",
                borderRight: "1px solid #eee",
                placeItems: "center",
              }}
            >
              <div>
                <Typography color="secondary.main" fontSize={12} style={{ color:"#fff" }}>
                  Vous êtes connecté en tant que 
                </Typography>
                <Typography fontWeight={500} fontSize={14} style={{ color:"#fff" }}>
                {`${conseiller?.firstName} ${conseiller?.lastName}`} <span style={{ color:"green" }}> ({`${conseiller?.accountType}`}) </span>
                </Typography>
              </div>
              <div className="Appbatabbtn"></div>
            </div>
            <Box className="feremtabn">
                    <Button variant="outlined" color="primary" size="small" className="tabbtn" onClick={returnToAdmin}>
                      <span> Retourner à L'administration</span>
                      <ChevronRight />
                    </Button>
              </Box>
          </div>
        </div>
      </div>
      </div> : null
  );
}
